import { render } from "./Add2Reabonnement.vue?vue&type=template&id=74bd7343&ts=true"
import script from "./Add2Reabonnement.vue?vue&type=script&lang=ts"
export * from "./Add2Reabonnement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__